<template>
  <div class="Dashbord">
    <FloatingButtonMultiSingleVineyard></FloatingButtonMultiSingleVineyard>
    <ActionsNavVinogradi></ActionsNavVinogradi>
    <div class="Actions__Content">
      <v-container fluid style="padding-bottom: 10px">
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom">
          <h2>{{ this.items.name }}</h2>

          <div class="TankHolder">
            <div
              class="VineyardDetails TankSingle"
              style="padding-top: 15px"
              :id="this.items.id"
              :key="this.items.id"
              :data-vineyard-id="this.items.id"
              :data-vineyard-name="this.items.name"
            >
              <div class="VineyardDetails__Item">
                <span class="label">Površina parcele:</span>
                <span class="value" v-if="this.items.surface !== null">{{
                  this.items.surface + " ha"
                }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Nadmorska visina:</span>
                <span
                  class="value"
                  v-if="this.items.altitude_in_meters !== null"
                  >{{ this.items.altitude_in_meters + " m" }}</span
                >
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Katastarska oznaka:</span>
                <span class="value">{{ this.items.cadastralMark }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Položaj:</span>
                <span
                  class="value"
                  v-if="this.items.exposition === null"
                ></span>
                <span
                  class="value"
                  v-else-if="this.items.exposition.length <= 30"
                  >{{ this.items.exposition }}</span
                >
                <span class="value" :title="this.items.exposition" v-else>{{
                  this.items.exposition.substring(0, 30) + "..."
                }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Lokacija:</span>
                <span class="value" v-if="this.items.location === null"></span>
                <span
                  class="value"
                  v-else-if="this.items.location.length <= 30"
                  >{{ this.items.location }}</span
                >
                <span class="value" :title="this.items.location" v-else>{{
                  this.items.location.substring(0, 30) + "..."
                }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Longituda:</span>
                <span class="value">{{ this.items.longitude }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Latituda:</span>
                <span class="value">{{ this.items.latitude }}</span>
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Sastav tla:</span>
                <span
                  class="value"
                  v-if="this.items.soilComposition === null"
                ></span>
                <span
                  class="value"
                  v-else-if="this.items.soilComposition.length <= 30"
                  >{{ this.items.soilComposition }}</span
                >
                <span
                  class="value"
                  :title="this.items.soilComposition"
                  v-else
                  >{{
                    this.items.soilComposition.substring(0, 30) + "..."
                  }}</span
                >
              </div>
              <div class="VineyardDetails__Item">
                <span class="label">Tip tla:</span>
                <span class="value1" v-if="this.items.soilType === null"></span>
                <span
                  class="value1"
                  v-else-if="this.items.soilType.length <= 25"
                  >{{ this.items.soilType }}</span
                >
                <span class="value1" :title="this.items.soilType" v-else>{{
                  this.items.soilType.substring(0, 25) + "..."
                }}</span>
                <span class="olovka">
                  <button @click="otvori_vinograde">
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Izmena podataka o vinogradu"
                    />
                  </button>
                </span>
              </div>
            </div>
            <div class="VineyardDetails" style="padding-top: 5px">
              <div class="VineyardDetails__Item">
                <div class="maka" title="Površina">
                  <p
                    class="amauntAvailable"
                    v-if="this.items.surfaceUnderPlantsInHa !== null"
                    v-html="this.items.surfaceUnderPlantsInHa"
                  ></p>
                  <p class="amauntAvailable" v-else v-html="'0'"></p>
                  <p style="font-size: 14px !important">ha</p>
                </div>
                <div class="maka">
                  <p
                    class="amauntAvailable"
                    v-html="this.items.blocks.length"
                  ></p>
                  <p
                    style="font-size: 14px !important"
                    v-html="formatTekstaParcelu2(this.items.blocks.length)"
                  ></p>
                </div>
              </div>
              <div class="VineyardDetails__Item">
                <div class="maka">
                  <p
                    class="amauntAvailable"
                    v-html="this.items.grapes.length"
                  ></p>
                  <p
                    style="font-size: 14px !important"
                    v-html="formatTekstaSorta2(this.items.grapes.length)"
                  ></p>
                </div>
                <div class="maka">
                  <p
                    class="amauntAvailable"
                    v-html="this.items.rows.length"
                  ></p>
                  <p
                    style="font-size: 14px !important"
                    v-html="formatTekstaRed2(this.items.rows.length)"
                  ></p>
                </div>
              </div>
              <div class="VineyardDetails__Item">
                <div class="maka">
                  <p class="amauntAvailable" v-html="this.items.plants"></p>
                  <p
                    style="font-size: 14px !important"
                    v-html="formatTekstaCokot(this.items.rows.length)"
                  ></p>
                </div>
                <!-- <div class="maka">Nesto.</div> -->
              </div>
            </div>
            <div class="VineyardDetails">
              <!-- <div
                class="VineyardDetails__Item"
                
              >
                <span class="label" style="width:100%; text-align: center;font-size: 24px;">Trenutna vreme za {{ this.grad }}, {{ this.drzava }}</span>
              </div> -->
              <div
                class="VineyardDetails__Item ssss"
              >
                <span
                  class="label2"
                  style="text-align: center; margin-bottom: 25px"
                  >{{ this.temperatura }} °C</span
                >
                <span id="icon" class="value2"
                  ><img id="wicon" :src="this.slika" alt="Weather icon"
                /></span>
              </div>
              <div class="VineyardDetails__Item mmmm">
                <span
                  class="label jopa"
                  
                  >Subjektivni osećaj: {{ this.osecaj }} °C</span
                >
                <span
                  class="label jopa"
                  >Brzina vetra: {{ this.brzina_vetra }} m/s</span
                >
                <span
                  class="label jopa"
                  >Vlaznost vazduha: {{ this.vlaznost }} %</span
                >
                <span
                  class="label jopa"
                  >Pritisak: {{ this.pritisak }} hPa</span
                >
              </div>
            </div>
          </div>
        </section></v-container
      >
      <v-container fluid style="padding-top: 10px; padding-bottom: 10px">
        <!-- <v-layout row wrap>
        <v-flex xs12>
          <v-btn @click="sadnja" class="AppButtonOutlined">Otvori sadnju</v-btn>
        </v-flex>
      </v-layout> -->

        <v-app id="inspire" class="TabClass">
          <v-tabs fixed-tabs v-model="selectedTab">
            <v-tab
              v-on:click.native="setDate('common')"
              style="padding-left: 20px; padding-right: 20px"
              >{{ tekstBiljka }}</v-tab
            >
            <!--  -->
            <v-tab
              v-on:click.native="setDate('planting')"
              style="padding-left: 20px; padding-right: 20px"
              >Sadnja, naslon i krčenje</v-tab
            >
          </v-tabs>
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="max-height: 60px !important; padding-top: 0px !important"
            >
              <template v-if="selectedTab === 0">
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menuOd"
                    v-model="menuOd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    background="white"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedOd"
                      label="Datum od"
                      readonly
                      @blur="dateOd = parseDate(dateFormattedOd)"
                      :rules="[(v) => !!v || 'Obavezan podatak']"
                      required
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateOd"
                      no-title
                      @input="menuOd = false"
                      :max="dateDo"
                    ></v-date-picker>
                    <!-- :min="dateOd" -->
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateOd = null;
                        $refs.menuOd.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menuDo"
                    v-model="menuDo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    background="white"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedDo"
                      label="Datum do"
                      readonly
                      @blur="dateDo = parseDate(dateFormattedDo)"
                      :rules="[(v) => !!v || 'Obavezan podatak']"
                      required
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateDo"
                      no-title
                      @input="menuDo = false"
                      :max="dateDo"
                    ></v-date-picker>
                    <!-- :min="dateOd" -->
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateDo = null;
                        $refs.menuDo.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menuOd"
                    v-model="menuOd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedOd"
                      label="Datum od"
                      readonly
                      @blur="dateOd = parseDate(dateFormattedOd)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateOd"
                      no-title
                      @input="menuOd = false"
                      :max="dateMax"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateOd = null;
                        $refs.menuOd.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menuDo"
                    v-model="menuDo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedDo"
                      label="Datum do"
                      readonly
                      @blur="dateDo = parseDate(dateFormattedDo)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateDo"
                      no-title
                      @input="menuDo = false"
                      :max="dateMax"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateDo = null;
                        $refs.menuDo.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
              </template>

              <v-flex xs9 pa-2>
                <v-autocomplete
                  v-model="article_to_select"
                  :items="article_to_items"
                  item-text="name"
                  item-value="id"
                  label="Operacije"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex flex xs1 pa-2 style="text-align: right">
                <v-btn @click="submitKartice" class="AppButtonFilled"
                  >Pretraži</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
          <template>
            <v-data-table
              :headers="headers_inputoutput"
              :items="items_inputoutput"
              class="TankTable"
              item-key="id"
              ref="dTable"
              :pagination.sync="pagination"
              :total-items="ukupnoRedova"
              :rows-per-page-items="listSize"
              style="padding-top: 15px"

hide-actions
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      header.sortable ? 'column sortable' : '',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.align === 'left'
                        ? 'text-xs-left'
                        : 'text-xs-center',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>

              <template slot="items" slot-scope="props">
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    pagination.rowsPerPage * (pagination.page - 1) + 
                    items_inputoutput
                      .map(function (x) {
                        return x.id;
                      })
                      .indexOf(props.item.id) + 1
                  }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ formatDate(props.item.date) }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.vineyardOperation }}
                </td>

                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.blocks.length > 5"
                >
                  {{ formatTekstaParcelu(props.item.blocks.length) }}
                  <v-menu
                    open-on-hover
                    top
                    offset-x
                    nudge-right="20"
                    close-delay="100"
                  >
                    <template v-slot:activator="{}">
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      {{ formatRedova(props.item.blocks) }}
                    </template>
                  </v-menu>
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else-if="props.item.blocks.length > 0"
                >
                  {{ formatRedova(props.item.blocks) }}
                </td>
                <td v-else></td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.tables.length > 2"
                >
                  {{ formatTekstaTabla(props.item.tables.length) }}
                  <v-menu
                    open-on-hover
                    top
                    offset-x
                    nudge-right="20"
                    close-delay="100"
                  >
                    <template v-slot:activator="{}">
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      <span>
                        <v-container style="background-color: white">
                          <div class="DataTable">
                            <v-layout column>
                              <v-flex style="overflow: auto">
                                <v-data-table
                                  :headers="headers_modal_tabla"
                                  :items="props.item.tables"
                                  hide-actions
                                  class="elevation-1"
                                  show-select
                                  dense
                                  select-all
                                >
                                  <template
                                    slot="headers"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <th
                                        style="text-align: center; padding: 5px"
                                        v-for="header in props_modal.headers"
                                        :key="header.text"
                                      >
                                        {{ header.text }}
                                      </th>
                                    </tr>
                                  </template>
                                  <template
                                    slot="items"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <td
                                        style="
                                          text-align: center;
                                          padding-left: 5px;
                                          padding-right: 5px;
                                        "
                                      >
                                        {{ props_modal.item }}
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-container>
                      </span>
                    </template>
                  </v-menu>
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else-if="props.item.tables.length > 0"
                >
                  {{ formatRedova(props.item.tables) }}
                </td>
                <td v-else></td>

                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.grapeVarieties.length > 2"
                >
                  {{ formatTekstaSorta(props.item.grapeVarieties.length) }}
                  <v-menu
                    open-on-hover
                    top
                    offset-x
                    nudge-right="20"
                    close-delay="100"
                  >
                    <template v-slot:activator="{}">
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      <span>
                        <v-container style="background-color: white">
                          <div class="DataTable">
                            <v-layout column>
                              <v-flex style="overflow: auto">
                                <v-data-table
                                  :headers="headers_modal_sorta"
                                  :items="props.item.grapeVarieties"
                                  hide-actions
                                  class="elevation-1"
                                  show-select
                                  dense
                                  select-all
                                >
                                  <template
                                    slot="headers"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <th
                                        style="text-align: center; padding: 5px"
                                        v-for="header in props_modal.headers"
                                        :key="header.text"
                                      >
                                        {{ header.text }}
                                      </th>
                                    </tr>
                                  </template>
                                  <template
                                    slot="items"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <td
                                        style="
                                          text-align: center;
                                          padding-left: 5px;
                                          padding-right: 5px;
                                        "
                                      >
                                        {{ props_modal.item }}
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-container>
                      </span>
                    </template>
                  </v-menu>
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else-if="props.item.grapeVarieties.length > 0"
                >
                  {{ formatRedova(props.item.grapeVarieties) }}
                </td>
                <td v-else></td>

                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.rows.length > 5"
                >
                  {{ formatTekstaRed(props.item.rows.length) }}
                  <v-menu
                    open-on-hover
                    top
                    offset-x
                    nudge-right="20"
                    close-delay="100"
                  >
                    <template v-slot:activator="{}">
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      <span>
                        <v-container style="background-color: white; z-index:1000;">
                          <div class="DataTable">
                            <v-layout column>
                              <v-flex style="overflow: auto">
                                <v-data-table
                                  :headers="headers_modal"
                                  :items="props.item.rows"
                                  hide-actions
                                  class="elevation-1"
                                  show-select
                                  dense
                                  select-all
                                  :custom-sort="customSort"
                                >
                                  <template
                                    slot="headers"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <th
                                        style="text-align: center; padding: 5px"
                                        v-for="header in props_modal.headers"
                                        :key="header.text"
                                      >
                                        {{ header.text }}
                                      </th>
                                    </tr>
                                  </template>
                                  <template
                                    slot="items"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <td
                                        style="
                                          text-align: center;
                                          padding-left: 5px;
                                          padding-right: 5px;
                                        "
                                      >
                                        {{ props_modal.item }}
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-container>
                      </span>
                    </template>
                  </v-menu>
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else-if="props.item.rows.length > 0"
                >
                  {{ formatRedova(props.item.rows) }}
                </td>
                <td v-else></td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.plants > 0"
                >
                  {{ currencyFormat(props.item.plants) }}
                </td>
                <td v-else></td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.surface > 1000"
                >
                  {{ Math.round(props.item.surface / 100) / 100 }} ha
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else-if="props.item.surface > 0"
                >
                  {{ Math.round(props.item.surface) / 100 }} ar
                </td>
                <td v-else></td>
                <td class="DataTable__ButtonHolder">
                  <img
                    class="DataTable__Button"
                    title="Izmena operacije"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="viewItem(props.item)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItem(props.item)"
                  />
                </td>
              </template>
              <!-- <template v-else>
                
              </template> -->

              <!-- </template> -->
            </v-data-table>
            <div class="text-xs-center pt-2">
                <v-layout
            row>
            <v-flex
              xs4
              ></v-flex>
            <v-flex
              xs2
              style="text-align: right;
    padding-right: 10px;
    padding-top: 23px;"
              >
              Redova na stranici:
            </v-flex>
            <v-flex
              xs1
              style="max-width:3%;"
              >
              <v-select
                v-model="redovaPoStrani"
                :items="listSize"
                item-text="text"
                item-value="value"
                persistent-hint
                v-on:change="changeOperation"
                style="font-size: 14px;"
              ></v-select>
            </v-flex>
            <v-flex
              xs2
              style="padding-top: 23px;padding-left: 10px;"
              v-if="pagination.rowsPerPage * pagination.page <= ukupnoRedova "
              >
              {{ 1 + pagination.rowsPerPage * (pagination.page - 1) + " - " + pagination.rowsPerPage * pagination.page + " od " + ukupnoRedova }}
              
            </v-flex>
            <v-flex
              xs2
              style="padding-top: 23px;padding-left: 10px;"
              v-else
              >
              {{ 1 + pagination.rowsPerPage * (pagination.page - 1) + " - " + ukupnoRedova + " od " + ukupnoRedova }}
              
            </v-flex>
            <v-flex
              xs2
              style="padding-top: 10px;
    text-align: left;"
              >
              <v-pagination v-model="pagination.page" :length="pages" :total-visible="5"></v-pagination>
            </v-flex>
            
          </v-layout>        
      </div>
          </template>
        </v-app>
      </v-container>
    </div>

    <v-dialog
      v-model="dialogNote_imena_vinograda"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Vinograd</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>
            <MyComponent
              @newdata="handleData($event)"
              @close="closeModal"
              :item="items_pom"
            ></MyComponent>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <!--  -->
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, prevediSveOperacije, daLiJeVinarija } from "../helpers/Functions";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import ActionsNavVinogradi from "./parts/ActionsNavVinogradi";
// import FloatingButtonMultiSingleVineyard from "./parts/FloatingButtonIzvestaj.vue";
import FloatingButtonMultiSingleVineyard from "./parts/FloatingButtonMultiSingleVineyard.vue";

import TokenComponent from "../components/Token";

const MountedMixin = {
  mounted() {
    // alert(1);
    this.$emit("mounted");
  },
};

import MyComponent from "../components/VineYardItemPomComponent.vue";

export default {
  name: "singleVineYard",
  dialog: false,
  components: {
    Breadcrumbs,
    TokenComponent,
    ActionsNavVinogradi,
    MyComponent,
    FloatingButtonMultiSingleVineyard,
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.ukupnoRedova == null
      ) return 0

      return Math.ceil(this.ukupnoRedova / this.pagination.rowsPerPage)
    },
    params(nv) {
      return {
        ...this.pagination,
        query: this.search,
      };
    },
  },
  data() {
    return {
      search: "",
      actionId: 0,
      pagination: {
        sortBy: "date",
        descending: true,
        rowsPerPage: 25,
        descending: true,
      },
      items: {
        id: 0,
        name: "",
        cadastralMark: "",
        location: "",
        surface: null,
        soilType: null,
        latitude: null,
        longitude: null,
        altitude_in_meters: null,
        soilComposition: null,
        exposition: null,
        description: null,
        blocks: [],
        rows: [],
        grapes: [],
        plants: null,
      },
      vineyard_id: 0,
      headers_modal: [
        {
          text: "Izabrani redovi",
          value: "tankNumberInBatch",
          align: "center",
        },
      ],
      headers_modal_tabla: [
        { text: "Izabrane table", value: "tankNumberInBatch", align: "center" },
      ],
      headers_modal_sorta: [
        { text: "Izabrane sorte", value: "tankNumberInBatch", align: "center" },
      ],
      headers_inputoutput: [
        { text: "" },
        { text: "Datum", value: "date", align: "center", sortable: true },
        {
          text: "Operacija",
          value: "vineyardOperation",
          align: "center",
          sortable: true,
        },
        { text: "Parcele", value: "", align: "center", sortable: false },
        { text: "Table", value: "", align: "center", sortable: false },
        { text: "Sorte", value: "", align: "center", sortable: false },
        { text: "Redovi", value: "", align: "center", sortable: false },
        { text: "Broj čokota", value: "", align: "center", sortable: false },
        { text: "Površina", value: "", align: "center", sortable: false },
        { text: "Funkcije", value: "funkcije", sortable: false },
      ],
      items_inputoutput: [],
      dozvoljena_izmena: 1,
      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateMax: null,
      dateFormattedDo: null,
      article_to_select: [],
      article_to_items: [],
      izabranaStranica: 0,
      listSize: [{ text: "5", value: 5 }, { text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "Svi", value: 1000000 }],
      redovaPoStrani: 25,
      ukupnoRedova: 0,
      selectedTab: 0,
      weather_data: undefined,
      slika: "https://openweathermap.org/img/wn/10d@2x.png",
      grad: undefined,
      drzava: undefined,
      temperatura: undefined,
      osecaj: undefined,
      pritisak: undefined,
      vlaznost: undefined,
      brzina_vetra: undefined,

      dialogNote_imena_vinograda: false,
      items_pom: undefined,
      floating_akcija: "1",

      naziv_vinograda: "",
      vinarija: true,
      tekstBiljka: "",
      tekstBiljka1: ""
    };
  },

  methods: {
    customSort(items, index, isDesc) {
  items.sort((a, b) => {
    if (Number(a) < Number(b)) {
    return -1;
  } else if (Number(a) > Number(b)) {
    return 1;
  }
  // a must be equal to b
  return 0;
  });
  return items;
},
    currencyFormat(num) {
      let odgovor = "";

      if (num !== undefined)
        odgovor = num
          .toFixed(0) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 "); // use . as a separator

      return odgovor;
    },
    changeOperation(a) {
      this.pagination.page = 1

      if(a=== 1000000)
        this.pagination.rowsPerPage = this.ukupnoRedova;
      else
        this.pagination.rowsPerPage = a;
    },
    handleData: function (e) {
      this.ucitavanjePodataka();
      this.dialogNote_imena_vinograda = false;
      this.items_pom = undefined;
    },
    otvori_vinograde(e) {
      e.preventDefault();
      this.dialogNote_imena_vinograda = true;

      this.items_pom = this.items;
    },
    closeModal() {
      this.dialogNote_imena_vinograda = false;
      this.items_pom = undefined;
    },
    formatTekstaCokot(broj) {
      let tekst = "";
      
      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = broj + " reda";
      else tekst = broj + " redova";

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    formatTekstaSorta(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = broj + " sorte";
      else tekst = broj + " sorti";

      return tekst;
    },
    formatTekstaTabla(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " tabla";
      else tekst = broj + " tabli";

      return tekst;
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaParcelu(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " parcela";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = broj + " parcele";
      else tekst = broj + " parcela";

      return tekst;
    },
    formatTekstaParcelu2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "parcela";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "parcele";
      else tekst = "parcela";

      return tekst;
    },
    viewItem(item) {
      let akcija = 0;

      if (item.vineyardOperationType === "MACHIN") akcija = 1;
      else if (item.vineyardOperationType === "HAND") akcija = 2;
      else if (item.vineyardOperationType === "FITO") akcija = 3;
      else if (item.vineyardOperationType === "HARVEST") akcija = 4;
      else if (item.vineyardOperationType === "STATE") akcija = 5;
      else if (item.vineyardOperationType === "PARAMETERS") akcija = 6;
      else if (item.vineyardOperationType === "PLANTING") akcija = 7;
      else if (item.vineyardOperationType === "DESTROYING") akcija = 8;

      serverBus.$emit("open_modal", akcija, item.vineyardOperationType, item);
    },
    deleteItem(item) {
      confirm(
        "Da li ste sigurni da želite obrisati operaciju " +
          item.vineyardOperation +
          "?"
      ) && this.deleteSifarnik(item.id);
    },
    deleteSifarnik(id) {
      let _this = this;

      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // // console.log(response);
          _this.getAllSifarnik();

          

          if (_this.selectedTab === 0) _this.getAllKartice("common");
          else _this.getAllKartice("planting");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              _this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  _this.$http
                    .delete(
                      _this.globalServiceLocation +
                        _this.globalPort +
                        "/vineyard_operation_execution/delete/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);

                      _this.getAllSifarnik();


                      if (_this.selectedTab === 0)
                        _this.getAllKartice("common");
                      else _this.getAllKartice("planting");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatRedova(niz) {
      let tekst = "";

      if (niz.length > 0) {
        niz.forEach(function (entry) {
          tekst = tekst + entry + ", ";
        });

        tekst = tekst.substring(0, tekst.length - 2);
      }

      return tekst;
    },
    submitKartice() {
      

      if (this.selectedTab === 0) {
        if (this.$refs.form.validate()) this.getAllKartice("common");
      } else this.getAllKartice("planting");
    },
    submit() {
      this.search = "";
      this.getAllPromene();
    },
    getAllArticlesKartica(tip) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation/" +
            tip,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.article_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation/" +
                        tip,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllKartice(tip) {
      var pom_article_to_select = "";

      if (
        this.article_to_select.length > 0
      )
        this.article_to_select.forEach(function (entry) {
          pom_article_to_select =
            pom_article_to_select + "&operationId=" + entry.id;
        });

      let strDate = "";
      if (this.dateOd !== null && this.dateOd !== undefined)
        strDate = "from=" + this.dateOd + "&"; // + "T00:00&";

      let strDateDo = "";
      if (this.dateDo !== null && this.dateDo !== undefined)
        strDateDo = "to=" + this.dateDo + "&"; // + "T23:59&";

      let pageLoc = "page=" + this.izabranaStranica + "&";

      let offsetLoc = "offset=" + this.pagination.rowsPerPage + "&";

      let sortiranje = "";
      if (
        this.pagination.sortBy === "date" ||
        this.pagination.sortBy === "vineyardOperation"
      ) {
        let orderovanje = "";
        if (this.pagination.descending) orderovanje = "desc&";
        else orderovanje = "asc&";

        sortiranje =
          "sort=" +
          this.pagination.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje +
          "&";
      }

      let urlLoc =
        "/vineyard_operation_execution/vineyard/" +
        this.vineyard_id +
        "/" +
        tip +
        "?" +
        pom_article_to_select +
        "&" +
        sortiranje;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            urlLoc +
            strDate +
            strDateDo +
            pageLoc +
            offsetLoc,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_inputoutput = response.data.content;

          this.ukupnoRedova = response.data.totalElements;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        urlLoc +
                        strDate +
                        strDateDo +
                        "page=" +
                        this.izabranaStranica +
                        "&offset=" +
                        this.pagination.rowsPerPage,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_inputoutput = response.data.content;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDateM(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    routerLinkToDetails(lokID, lokIDTank, lokActive) {
      this.$router.push({
        name: "single_tank",
        params: { id: lokID, idTank: lokIDTank, active: lokActive },
      });
    },
    formatDateTime(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    formatDate(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    formatTank_U(stringLok, nazivTanka) {
      let pomStr = "";

      if (stringLok == "OUT") pomStr = nazivTanka;
      else pomStr = "";
      return pomStr;
    },
    formatTank_IZ(stringLok, nazivTanka) {
      let pomStr = "";

      if (stringLok == "IN") pomStr = nazivTanka;
      else pomStr = "";
      return pomStr;
    },
    prevediOperacijeLok(stringLok) {
      let pomStr = "";

      pomStr = prevediSveOperacije(stringLok);

      return pomStr;
    },
    changeSort(column) {
      if (column !== "funkcije" && column !== "")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard/" +
            this.vineyard_id +
            "/extended",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items = response.data;
          this.items_pom = response.data;
          this.naziv_vinograda = response.data.name;

          let nizVrednosti = [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                true,
              ];
              serverBus.$emit("disable_action_vineyard", nizVrednosti);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard/" +
                        this.vineyard_id +
                        "/extended",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                      this.items_pom = response.data;
                      this.naziv_vinograda = response.data.name;
                    })
                    .catch((e) => {
                      // // console.log(321);

                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    ucitavanjePodataka() {
      this.vineyard_id = this.$route.params.id;

      this.getAllSifarnik();
    },
    setDate(tip) {
      

      if (tip !== "planting") {
        const today = new Date();
        let Year = `${today.getFullYear()}`;
        let Month = `${today.getMonth() + 1}`;
        let Day = `${today.getDate()}`;

        if (Month.length < 2) Month = `0${Month}`;
        if (Day.length < 2) Day = `0${Day}`;

        this.dateOd = [Year, Month, "01"].join("-");
        this.dateFormattedOd = this.formatDate1(this.dateOd);

        this.dateDo = [Year, Month, Day].join("-");
        this.dateMax = [Year, Month, Day].join("-");

        this.dateFormattedDo = this.formatDate1(this.dateDo);

        this.article_to_select = [];
      } else {
        this.dateOd = undefined;
        this.dateDo = undefined;

        this.clear();
      }

      this.getAllArticlesKartica(tip);
      this.getAllKartice(tip);
    },
    setDateInit(tip) {
      if (tip !== "planting") {
        const today = new Date();
        let Year = `${today.getFullYear()}`;
        let Month = `${today.getMonth() + 1}`;
        let Day = `${today.getDate()}`;

        if (Month.length < 2) Month = `0${Month}`;
        if (Day.length < 2) Day = `0${Day}`;

        this.dateOd = [Year, Month, "01"].join("-");
        this.dateFormattedOd = this.formatDate1(this.dateOd);

        this.dateDo = [Year, Month, Day].join("-");
        this.dateMax = [Year, Month, Day].join("-");

        this.dateFormattedDo = this.formatDate1(this.dateDo);

        this.article_to_select = [];
      } else {
        this.dateOd = undefined;
        this.dateDo = undefined;

        this.clear();
      }
    },
    getDataWeather() {
      let grad = localStorage.getItem("city");

      let url =
        "https://api.openweathermap.org/data/2.5/weather?q=" +
        grad +
        ",rs&appid=95b790814a2decba535811d5b7ed4811&units=metric";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.weather_data = response.data;

          this.slika =
            "https://openweathermap.org/img/wn/" +
            response.data.weather[0].icon +
            "@2x.png";

          this.grad = response.data.name;
          this.drzava = response.data.sys.country;
          this.temperatura = Math.round(response.data.main.temp);
          this.osecaj = Math.round(response.data.main.feels_like);
          this.pritisak = response.data.main.pressure;
          this.vlaznost = response.data.main.humidity;
          this.brzina_vetra = response.data.wind.speed;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    })
                    .then((response) => {
                      this.weather_data = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.message);
                      alert(1);
                      // alert(this.$lang.general.greskaNaServeru);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    clear() {
      this.$refs.form.reset();
      this.items_inputoutput = [];
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (
          newVal.page !== oldVal.page ||
          newVal.rowsPerPage !== oldVal.rowsPerPage ||
          newVal.sortBy !== oldVal.sortBy ||
          newVal.descending !== oldVal.descending
        ) {
          this.izabranaStranica = this.pagination.page - 1;

          

          if (this.selectedTab === 0) this.getAllKartice("common");
          else this.getAllKartice("planting");
        }
      },
      deep: true,
    },
    $route() {
      this.ucitavanjePodataka();
      this.getAllArticlesKartica("common");
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
  },
  beforeMount() {
    serverBus.$off("ucitaj_podatke_vinogradi");
    this.ucitavanjePodataka();
    this.getAllArticlesKartica("common");

    serverBus.$on("ucitaj_podatke_vinogradi", () => {
      // if (this.dozvoljena_izmena)
      this.getAllSifarnik();

      

      if (this.selectedTab === 0) this.getAllKartice("common");
      else this.getAllKartice("planting");
    });
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija){
      this.tekstBiljka = "OBRADA VINOGRADA";
    }
    else{
      this.tekstBiljka = "OBRADA ZASADA";

      this.headers_inputoutput = [
        { text: "" },
        { text: "Datum", value: "date", align: "center", sortable: true },
        {
          text: "Operacija",
          value: "vineyardOperation",
          align: "center",
          sortable: true,
        },
        { text: "Parcele", value: "", align: "center", sortable: false },
        { text: "Table", value: "", align: "center", sortable: false },
        { text: "Sorte", value: "", align: "center", sortable: false },
        { text: "Redovi", value: "", align: "center", sortable: false },
        { text: "Broj biljaka", value: "", align: "center", sortable: false },
        { text: "Površina", value: "", align: "center", sortable: false },
        { text: "Funkcije", value: "funkcije", sortable: false },
      ]
    }

    this.setDateInit("common");

    this.getDataWeather();
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/viewStyles/EmptySingleTank";
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_warehousesType.scss";

.VineyardDetails.TankSingle {
  // height: 270px !important;
  border-left: none;
}

.TankHolder {
  height: 270px !important;
}

.columnVineType {
  float: left;
  text-align: left;
  margin-bottom: 0px;
}

.columnRight {
  float: right;
  color: #8e302f;
  font-weight: bold;
}

.columnRightVineType {
  float: right;
  color: #018389;
  font-weight: bold;
  padding-left: 5px;
}
/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.TabClass {
  h2 {
    display: flex;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 15px;
    // text-transform: uppercase;
    border-bottom: 2px solid #930022;
    padding-top: 10px;
  }
}

// .v-tooltip__content {
//   font-size: 14px !important;
//   color: black;
//   opacity: 1 !important;
//   background-color: white !important;
//   font-family: Roboto, sans-serif;
// }

div.maka {
  height: 75px;
  width: 19% !important;
  border: 1px solid;
  background-color: #018389;
  margin-left: 19% !important;
  margin-top: 10px !important;
  color: white !important;
  text-align: center;

  @media (max-width: 1200px) {
    width: 30% !important;
    margin-left: 10% !important;
  }
}

.menuable__content__active {
  background-color: white;
}

.jopa{
  width: 100%; text-align: center; font-size: 18px;
                  @media (max-width: 1200px) {
                    font-size: 16px !important;
                    max-width: 100% !important;
                  }
}

.mmmm{
                  @media (max-width: 1200px) {
                    max-width: 100% !important;
                  }
}

.ssss{
  font-weight: 600;
                  font-size: 48px;
                  line-height: 1.3;
                  color: #333;
                  margin: 0 auto;
                  letter-spacing: -4px;
                  padding-right: 15px;

                  @media (max-width: 1200px) {
                    font-size: 32px;
                  }
}
</style>
